import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-navy-900" data-id="element-262">
      <div className="max-w-4xl mx-auto px-6" data-id="element-263">
        <FadeIn data-id="element-264">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-12" data-id="element-265">
            Después de los 50 años, tu cuerpo ya no juega con las mismas reglas.
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-266">
          <FadeIn delay={0.2} data-id="element-267">
            <p className="text-body-lg text-cream-muted mb-6" data-id="element-268">
              Tu glándula pineal se vuelve menos eficiente y tu sistema nervioso
              se vuelve hipersensible al cortisol.
            </p>
            <p className="text-body-lg text-cream-muted" data-id="element-269">
              El insomnio a esta edad no es una falta de sueño, es una{' '}
              <strong className="text-gold-400 font-normal" data-id="element-270">
                descalibración interna
              </strong>
              . Seguir los consejos que le dan a un joven de 20 años es como
              tratar de arreglar un motor moderno con herramientas de madera.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} direction="left" data-id="element-271">
            <div className="bg-navy-800 border border-navy-700 p-8 rounded-sm relative overflow-hidden" data-id="element-272">
              <div className="absolute top-0 left-0 w-1 h-full bg-gold-500" data-id="element-273"></div>
              <AlertCircleIcon className="w-8 h-8 text-gold-500 mb-4" data-id="element-274" />
              <p className="text-lg font-medium text-cream" data-id="element-275">
                Si no ajustas tu temperatura interna y tu ritmo hormonal de
                forma natural, tu cuerpo seguirá atrapado en el ciclo de fatiga
                crónica.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}